import script from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=2c680cae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c680cae"]])

export default __exports__